import React from 'react';
import styled from 'styled-components';

import ArrowRight from '@lt/components/icons-react/ArrowRight';

import { SCROLL_BUTTON_TEST_ID } from '../../constants';
import { RELINKING_VARIANTS } from '../../../../constants';

import type { IScrollButton } from '../../types';
import type { RelinkingBlockVariant } from '../../../../types';

export const ScrollButton = (props: IScrollButton): JSX.Element => {
  const { isLeft = false, handleScroll, variant } = props;

  const ArrowIcon = isLeft ? ArrowLeftIcon : ArrowRightIcon;

  return (
    <ContainerShadow
      $isCountriesVariant={
        variant === RELINKING_VARIANTS.DEFAULT_COUNTRIES ||
        variant === RELINKING_VARIANTS.COUNTRIES_WITH_PRICES
      }
      $variant={variant}
      $isLeft={isLeft}
      data-testid={SCROLL_BUTTON_TEST_ID}
    >
      <CircleButton $variant={variant} onClick={handleScroll}>
        <ArrowIcon />
      </CircleButton>
    </ContainerShadow>
  );
};

const ContainerShadow = styled.div<{
  $variant: RelinkingBlockVariant;
  $isCountriesVariant: boolean;
  $isLeft: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ $isCountriesVariant }) =>
    $isCountriesVariant ? 'center' : 'flex-start'};
  align-items: center;

  position: sticky;
  ${({ $isLeft }) => ($isLeft ? 'left: -4px;' : 'right: -4px;')}

  padding-top: ${({ $isCountriesVariant, $variant }) =>
    ($isCountriesVariant && '0') ||
    ($variant === RELINKING_VARIANTS.NARRATIVE && 60) ||
    40}px;
  padding-bottom: ${({ $variant }) =>
    ($variant === RELINKING_VARIANTS.COUNTRIES_WITH_PRICES && 60) || '0'}px;

  background: linear-gradient(
    ${({ $isLeft }) => ($isLeft ? -90 : 90)}deg,
    rgba(243, 243, 243, 0) 0%,
    #f3f3f3 100%
  );

  z-index: 10;
`;

const CircleButton = styled.button<{ $variant: RelinkingBlockVariant }>`
  width: 40px;
  height: 40px;

  border: none;
  border-radius: 50%;
  background: #17181a;

  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  margin-left: 12px;
  margin-right: 12px;

  cursor: pointer;
`;

const ArrowRightIcon = styled(ArrowRight)`
  width: 8px;
  height: 18px;

  stroke: #e6e9ee;
`;

const ArrowLeftIcon = styled(ArrowRightIcon)`
  transform: scale(-1, 1);
`;
